/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import { resizeFile } from '@/utils/helper'
import { useAuth, useLocalStorage } from '@/hooks/common'
import { useUploadMedia } from './useUploadMedia'

interface param {
  file: File
  fileType?: number
}

export const useUploadCoverPicture = () => {
  const axios = useContext(AxiosContext)
  const uploadFile = useUploadMedia()
  const { basicInfo } = useAuth()
  const containerID = basicInfo.mobileContID
  return useMutation({
    mutationKey: [ReactQueryKeys.UPLOAD_COVER_PICTURE, containerID],
    mutationFn: async ({ file }: param): Promise<any> => {
      const image = await resizeFile(file)

      // Upload image
      const photo = await uploadFile.mutateAsync(image as string)

      // Save set upload image as cover
      const response = await axios.api.post('ajax/users', {
        requestType: 'profileCoverSave',
        format: 'json',
        profileCoverID: photo.egoID,
        profileCoverHash: photo.egoHash,
      })
      return response
    },
  })
}
